import { FilterGroup } from '../Tools/FilterGroup';
import { FiltersController } from '../Tools/FiltersController';
import { IFilter } from '../Tools/IFilter';


export class ShowUnavailableFilter implements IFilter {
    id: string;
    name?: string | null;
    type: string;
    nbColums?: number;
    controller: FiltersController;
    isFirst: boolean;
    isLast: boolean;

    parentGroup: FilterGroup;

    constructor(parentGroup: FilterGroup, isFirst: boolean, isLast: boolean, nbColumns: number) {
        this.id = 'showUnavailable';
        this.name = 'Non disponibles';
        this.type = 'showUnavailable';
        this.isFirst = isFirst;
        this.isLast = isLast;
        this.nbColums = nbColumns;
        this.controller = new FiltersController();
        this.parentGroup = parentGroup;
    }

    html(): string {
        let html = '';

        if (this.isFirst) {
            html += '<div class="noPadding" style="display: flex;flex-direction: row; justify-content: space-around;" id="showFilters">'
        }
        html += `
        <div class="${FilterGroup.getColumParam(this.nbColums!)}" style="width: fit-content;height: fit-content;">
            <input id="showUnavailable" class="btn-default" type="checkbox"> ${this.name}
        </div>
        `;
        if (this.isLast) {
            html += '</div>';
        }
        setTimeout(() => {
            if (this.parentGroup.isDestroyed) return;
            $('#showUnavailable').prop('checked', FilterGroup.filters.showUnavailable);
            this.controller.addEventListener('change', () => {
                let isChecked = $('#showUnavailable').is(':checked');
                FilterGroup.filters.showUnavailable = isChecked;
                FilterGroup.getUpdateFunctions(this.parentGroup.filtersFunction)(FilterGroup.filters);
            }, 'showUnavailable');
        });
        return html;
    }

    // Done
    generateStringFilter(): string {
        // We allow everything for graphic artists
        if (FilterGroup.filters.showForGraphicArtists === true) {
            return('');
        }

        if (!FilterGroup.smartSearch()) {
            if (FilterGroup.filters.showUnavailable !== true) {
                if (FilterGroup.filters.showContentFactory === true) {
                    return('&q.pipeline.state.in=available,archived');
                }
                else {
                    // only AVAILABLE display
                    //stringFilters += '&q.pipeline.state.eq=available';
                    // ARCHIVED + AVAILABLE display
                    return('&q.pipeline.state.in=available,archived');
                }
            }
            else {
                if (FilterGroup.filters.showContentFactory === true) {
                    return('&q.pipeline.state.in=pending');
                }
                else {
                    return('&q.pipeline.state.in=available,archived,terminated');
                }
            }
        }
        else {
            if ((FilterGroup.filters.showUnavailable === true) && (FilterGroup.filters.showContentFactory === true)) {
                return('&q.pipeline.state.in=pending&q.pipeline.quality.eq=high');
            }
            else {
                if (FilterGroup.filters.showContentFactory === true) {
                    return('&q.pipeline.state.in=available,archived&q.pipeline.quality.eq=high');
                }
                else {
                    return('&q.pipeline.state.in=available,archived,terminated');
                }
            }
        }
    }

    destroy(): void {
        this.controller.destroy();
    }

}